import type { HubJob } from '@robovision/hub'
import { JobV2 } from '../jobV2/Job'


interface DriftDetectionParams {
  job: JobV2
}

export class DriftDetection extends JobV2 {
  constructor (params: DriftDetectionParams) {
    super(params.job)
  }

  public static fromJob (job: JobV2): DriftDetection {
    return new DriftDetection({
      job,
    })
  }

  public static override fromResponse (response: HubJob): DriftDetection {
    return new DriftDetection({
      job: JobV2.fromResponse(response),
    })
  }
}
